<template>
  <base-modal :visible="visible" @update:visible="close" :showClose="false">
    <div>
      <div class="content">

        <template v-if="showLowStock">
          <div class="content-title">
            {{ shorex ? '该线路' : '该产品库存' }} <div class="content-title-span">
              <div class="content-title-yellow"></div>
              <span style="z-index: 2;position: relative;">即将售罄</span>
            </div>
          </div>

          <div class="content-text" v-if="shorex">
            推荐您尽快预订锁定心仪线路
          </div>

          <div class="content-text" v-else>
            推荐您尽快预订锁定心仪时段
          </div>

        </template>

        <template v-if="outOfStock">
          <div class="content-title">
            {{ shorex ? '该线路' : '该产品库存' }} <div class="content-title-span">
              <div class="content-title-yellow"></div>
              <span style="z-index: 2;position: relative;">已售罄</span>
            </div>
          </div>

          <template v-if="shorex">
            <div class="content-text">
              推荐您预订其他线路
            </div>
          </template>

          <template v-else>
            <div class="content-text" style="margin-bottom: 4px;">
              推荐您预订其他同类产品或点击<span class="content-text-yellow">“到货提醒” </span>
            </div>
            <div class="content-text">
              有库存后将以短信的形式通知您
            </div>
          </template>



        </template>

      </div>
      <div class="btn-box" @click="close">
        已知悉
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
export default {
  components: {
    BaseModal
  },

  props: {
    visible: Boolean,
    showLowStock: {
      type: Boolean,
      default: false
    },
    outOfStock: {
      type: Boolean,
      default: false
    },
    shorex: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close() {
      console.log('close')
      this.$emit('update:visible', false)
    },
  }

}
</script>

<style lang="less" scoped>
::v-deep .dialog-card {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
}

// ::v-deep .custom-overlay {
//   background-color: rgba(0, 0, 0, 0.2);
// }

.content {
  padding: 64px 56px;
  color: #333333;
  font-size: 28px;
}

.content-title {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.content-title-span {
  position: relative;
  width: 114px;
  margin-left: 4px;
}

.content-text {
  text-align: center;
}

.content-title-yellow {

  position: absolute;
  background: linear-gradient(to right, #ffda17 0%, #fdbf01 100%);
  width: 114px;
  height: 12px;
  left: 0;
  bottom: 8px;
  z-index: 1;
}

.btn-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 86px;
  background: linear-gradient(to right, #ffda17 0%, #fdbf01 100%);
  color: #333333;
  font-size: 30px;
}

.content-text-yellow {
  font-weight: bold;
  color: #fdbf01;
}
</style>